import React from 'react';
import { UserPlus, ClipboardCheck, Mail } from 'lucide-react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const HowItWorks = () => {
    const steps = [
        {
            number: "01",
            icon: UserPlus,
            title: "Registrati e completa il tuo profilo inserendo i dettagli",
            description: "Crea il tuo account e compila le tue informazioni personali per iniziare a utilizzare i nostri servizi."
        },
        {
            number: "02",
            icon: ClipboardCheck,
            title: "Compila il modulo di richiesta per il servizio di cui hai bisogno",
            description: "Seleziona il servizio che ti serve e completa la documentazione necessaria."
        },
        {
            number: "03",
            icon: Mail,
            title: "Ricevi la conferma della tua richiesta via email",
            description: "Ricevi aggiornamenti immediati sullo stato della tua richiesta attraverso diversi canali."
        }
    ];


    return (
        <section className="py-12 md:py-20 px-6 bg-gradient-to-b from-gray-50 to-white">
            <div className="max-w-7xl mx-auto">
                {/* Title */}
                <h2 className="text-lg md:text-4xl font-bold text-start md:text-center text-slate-800 mb-2">
                    Scopri come funziona <span className="text-[#F2C231]">CAF ONLINE.</span>
                </h2>
                <p className="text-start md:text-center text-gray-600 text-xs md:text-lg mb-8">
                    Ottieni il tuo servizio in tre semplici passaggi, senza alcuno sforzo o perdita di tempo.
                </p>


                {/* Steps Grid */}
                <div className="grid md:grid-cols-3 gap-12">
                    {steps.map((step, index) => {
                        const IconComponent = step.icon;
                        return (
                            <div key={index} className="relative">
                                {/* Step Number Background */}
                                <div className="flex flex-col md:block relative">
                                    {/* Number */}
                                    <div className="absolute -top-1 md:-top-4 left-1 md:left-0 text-4xl md:text-8xl font-bold text-gray-200 select-none md:static md:mb-0 mr-4 md:mr-0">
                                        {step.number}
                                    </div>

                                    {/* Content Wrapper */}
                                    <div className="flex items-center md:block relative pt-0">
                                        {/* Icon */}
                                        <div className="w-16 h-10 md:w-24 md:h-24 bg-[#F2C231] rounded-lg md:rounded-2xl flex items-center justify-center mb-0 md:mb-6 shadow-lg transform hover:scale-105 transition-transform duration-300 mr-3 md:mr-0">
                                            <IconComponent className="w-12 h-6 md:w-12 md:h-12 text-white" strokeWidth={2} />
                                        </div>

                                        {/* Text Content */}
                                        <div>
                                            <h3 className="text-base md:text-xl font-bold text-slate-800 mb-1 md:mb-3 leading-snug">
                                                {step.title}
                                            </h3>
                                            <p className="text-gray-600 text-xs leading-relaxed">
                                                {step.description}
                                            </p>
                                        </div>
                                    </div>
                                </div>


                                {/* Connecting Arrow (except for last item) */}
                                {index < steps.length - 1 && (
                                    <div className="hidden md:block absolute top-32 -right-6 text-slate-800">
                                        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                            <path d="M5 12h14m-7-7l7 7-7 7" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>

                {/* CTA Button */}
                <div className="text-center mt-8">
                    <Link to='/signup' className="px-4 py-2 md:px-8 md:py-4 bg-slate-800 text-white font-semibold rounded-lg hover:bg-slate-600 transition-colors duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1">
                        Inizia ora
                    </Link>
                </div>
            </div>
        </section>
    );
};

export default HowItWorks;